export default __webpack_public_path__ + "static/media/LogoTeresa.3e586157.png";